import { Modal } from "react-bootstrap";
import styled from "styled-components";

export const UserStatusStyles = styled(Modal)`
  .modal-body {
    padding: 24px;
    height: calc(100vh - 104px);
    overflow: auto;

    .company-details {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      padding-bottom: 12px;
      border-bottom: 1px solid var(--Neutral-4);

      .user-status {
        width: 100%;

        .section-label {
          display: flex;
          align-items: center;
          gap: 4px;
          color: var(--Neutral-60);
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: -0.012px;

          svg {
            width: 12px;
            height: 12px;
          }
        }

        .main-text {
          color: var(--Neutral-100);
          font-size: 14px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: -0.021px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .users-title {
      color: var(--Neutral-100);
      font-size: 14px;
      font-weight: 600;
      margin: 12px 0;
    }

    .users-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .user-card {
      display: flex;
      gap: 12px;
      padding: 14px;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
    }

    .user-icon {
      width: 36px;
      height: 36px;
      min-width: 36px;
      border-radius: 50%;
      background: #f5f5f5;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    .user-info {
      min-width: 0;
    }

    .user-name {
      color: var(--Neutral-100);
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: -0.021px;
    }

    .user-email,
    .user-phone {
      margin: 0;
      color: var(--Neutral-60);
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.018px;
    }
  }
`;
